import { Menu } from '../../../components/Menu'
import { useOpenForCommentController } from './OpenForCommentController'
import "./OpenForComment.scss";
import OpenForCommentTable from './components/OpenForCommentTable';
import { DraftPreviewModal } from '../../../stateOffice/pages/WorkQueue/components/DraftPreviewModal';

export const OpenForComment = () => {
  const { loading, tableData, platform, } = useOpenForCommentController();
  return (
    <div className="open-for-comment">
      <header className="app-bar">
        <nav>
          <Menu title={"Home"} OS={platform}></Menu>
        </nav>
      </header>
      <main id="open-for-comment">
        <h1 className="open-for-comment-title">Open For Comment</h1>
        <hr className="underline" />
        {tableData ? (
          <OpenForCommentTable rows={tableData.rows} columns={tableData.columns} loading={loading} />
        ) : null}
      </main>
    </div>
  )
}
